module.exports = __webpack_public_path__ + "img/services-4.7f939020.jpg";